import { useState, useEffect } from 'react'

import { MysqlCategories, MysqlCategoriesEdge, MysqlRanksGroupConnection } from '../graphqlTypes'

export default function useMenu(
  categories: MysqlCategoriesEdge[],
  ranks: MysqlRanksGroupConnection[]
): MysqlCategoriesEdge[] {
  const [menu, setMenu] = useState<MysqlCategoriesEdge[]>([])

  useEffect(() => {
    const result = categories.map(parent => {
      const children = parent.node.categories as MysqlCategories[]
      parent.node.categories = children
        .map(child => {
          if (!child.fields) child.fields = {}

          const rank = ranks.find(({ fieldValue }) => child.mysqlId === parseInt(fieldValue as string, 10))
          if (rank && rank.edges.length > 0) {
            const target = rank.edges.find(({ node }) => node.rank === 1)
            child.fields.imageUrl = target ? target.node.products!.fields!.imageUrl : ''
          }

          return child
        })
        .filter(child => child.fields!.imageUrl !== '')

      return parent
    })

    setMenu(result)
  }, [])

  return menu
}
